/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CheckPointDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Create
 */
export const postCheckpoint = (
  checkPointDto: CheckPointDto,
  signal?: AbortSignal,
) => {
  return customInstance<CheckPointDto>({
    url: `/checkpoint`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: checkPointDto,
    signal,
  });
};

export const getPostCheckpointMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCheckpoint>>,
    TError,
    { data: CheckPointDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCheckpoint>>,
  TError,
  { data: CheckPointDto },
  TContext
> => {
  const mutationKey = ["postCheckpoint"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCheckpoint>>,
    { data: CheckPointDto }
  > = (props) => {
    const { data } = props ?? {};

    return postCheckpoint(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCheckpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCheckpoint>>
>;
export type PostCheckpointMutationBody = CheckPointDto;
export type PostCheckpointMutationError = void;

/**
 * @summary Create
 */
export const usePostCheckpoint = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCheckpoint>>,
      TError,
      { data: CheckPointDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCheckpoint>>,
  TError,
  { data: CheckPointDto },
  TContext
> => {
  const mutationOptions = getPostCheckpointMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find All By Project Id
 */
export const getCheckpointProjectProjectId = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<CheckPointDto[]>({
    url: `/checkpoint/project/${projectId}`,
    method: "GET",
    signal,
  });
};

export const getGetCheckpointProjectProjectIdInfiniteQueryKey = (
  projectId?: number,
) => {
  return ["infinite", `/checkpoint/project/${projectId}`] as const;
};

export const getGetCheckpointProjectProjectIdQueryKey = (
  projectId?: number,
) => {
  return [`/checkpoint/project/${projectId}`] as const;
};

export const getGetCheckpointProjectProjectIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCheckpointProjectProjectIdInfiniteQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
  > = ({ signal }) => getCheckpointProjectProjectId(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCheckpointProjectProjectIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
>;
export type GetCheckpointProjectProjectIdInfiniteQueryError = void;

export function useGetCheckpointProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find All By Project Id
 */

export function useGetCheckpointProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCheckpointProjectProjectIdInfiniteQueryOptions(
    projectId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCheckpointProjectProjectIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCheckpointProjectProjectIdQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
  > = ({ signal }) => getCheckpointProjectProjectId(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCheckpointProjectProjectIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
>;
export type GetCheckpointProjectProjectIdQueryError = void;

export function useGetCheckpointProjectProjectId<
  TData = Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointProjectProjectId<
  TData = Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointProjectProjectId<
  TData = Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find All By Project Id
 */

export function useGetCheckpointProjectProjectId<
  TData = Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCheckpointProjectProjectIdQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update
 */
export const putCheckpointId = (id: number, checkPointDto: CheckPointDto) => {
  return customInstance<CheckPointDto>({
    url: `/checkpoint/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: checkPointDto,
  });
};

export const getPutCheckpointIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCheckpointId>>,
    TError,
    { id: number; data: CheckPointDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCheckpointId>>,
  TError,
  { id: number; data: CheckPointDto },
  TContext
> => {
  const mutationKey = ["putCheckpointId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCheckpointId>>,
    { id: number; data: CheckPointDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putCheckpointId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCheckpointIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCheckpointId>>
>;
export type PutCheckpointIdMutationBody = CheckPointDto;
export type PutCheckpointIdMutationError = void;

/**
 * @summary Update
 */
export const usePutCheckpointId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putCheckpointId>>,
      TError,
      { id: number; data: CheckPointDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putCheckpointId>>,
  TError,
  { id: number; data: CheckPointDto },
  TContext
> => {
  const mutationOptions = getPutCheckpointIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Id
 */
export const getCheckpointId = (id: number, signal?: AbortSignal) => {
  return customInstance<CheckPointDto>({
    url: `/checkpoint/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetCheckpointIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/checkpoint/${id}`] as const;
};

export const getGetCheckpointIdQueryKey = (id?: number) => {
  return [`/checkpoint/${id}`] as const;
};

export const getGetCheckpointIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCheckpointIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCheckpointId>>> = ({
    signal,
  }) => getCheckpointId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCheckpointId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCheckpointIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCheckpointId>>
>;
export type GetCheckpointIdInfiniteQueryError = void;

export function useGetCheckpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetCheckpointIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCheckpointIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCheckpointIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCheckpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCheckpointIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCheckpointId>>> = ({
    signal,
  }) => getCheckpointId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCheckpointId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCheckpointIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCheckpointId>>
>;
export type GetCheckpointIdQueryError = void;

export function useGetCheckpointId<
  TData = Awaited<ReturnType<typeof getCheckpointId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointId<
  TData = Awaited<ReturnType<typeof getCheckpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointId>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointId<
  TData = Awaited<ReturnType<typeof getCheckpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetCheckpointId<
  TData = Awaited<ReturnType<typeof getCheckpointId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCheckpointIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteCheckpointId = (id: number) => {
  return customInstance<boolean>({
    url: `/checkpoint/${id}`,
    method: "DELETE",
  });
};

export const getDeleteCheckpointIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCheckpointId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCheckpointId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCheckpointId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCheckpointId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCheckpointId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCheckpointIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCheckpointId>>
>;

export type DeleteCheckpointIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteCheckpointId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCheckpointId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCheckpointId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteCheckpointIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Task Id
 */
export const getCheckpointTaskIdTask = (
  taskId: number,
  signal?: AbortSignal,
) => {
  return customInstance<CheckPointDto>({
    url: `/checkpoint/${taskId}/task`,
    method: "GET",
    signal,
  });
};

export const getGetCheckpointTaskIdTaskInfiniteQueryKey = (taskId?: number) => {
  return ["infinite", `/checkpoint/${taskId}/task`] as const;
};

export const getGetCheckpointTaskIdTaskQueryKey = (taskId?: number) => {
  return [`/checkpoint/${taskId}/task`] as const;
};

export const getGetCheckpointTaskIdTaskInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointTaskIdTask>>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCheckpointTaskIdTaskInfiniteQueryKey(taskId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
  > = ({ signal }) => getCheckpointTaskIdTask(taskId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!taskId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCheckpointTaskIdTaskInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
>;
export type GetCheckpointTaskIdTaskInfiniteQueryError = void;

export function useGetCheckpointTaskIdTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointTaskIdTask>>>,
  TError = void,
>(
  taskId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointTaskIdTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointTaskIdTask>>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointTaskIdTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointTaskIdTask>>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Task Id
 */

export function useGetCheckpointTaskIdTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCheckpointTaskIdTask>>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCheckpointTaskIdTaskInfiniteQueryOptions(
    taskId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCheckpointTaskIdTaskQueryOptions = <
  TData = Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCheckpointTaskIdTaskQueryKey(taskId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
  > = ({ signal }) => getCheckpointTaskIdTask(taskId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!taskId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCheckpointTaskIdTaskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
>;
export type GetCheckpointTaskIdTaskQueryError = void;

export function useGetCheckpointTaskIdTask<
  TData = Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
  TError = void,
>(
  taskId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointTaskIdTask<
  TData = Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
          TError,
          Awaited<ReturnType<typeof getCheckpointTaskIdTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckpointTaskIdTask<
  TData = Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Task Id
 */

export function useGetCheckpointTaskIdTask<
  TData = Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
  TError = void,
>(
  taskId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckpointTaskIdTask>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCheckpointTaskIdTaskQueryOptions(taskId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
